import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';

import { isMobile } from 'utils/menuHelper';
import Logo from 'images/logo_black.png';

import { useDispatch, useSelector } from 'react-redux';

import LoginForm from 'components/form/Login';
import { Creators } from 'store/ducks/auth';
import styles from './styles';

const initialValues = {
  email: '',
  password: '',
  rememberMe: false,
};

const Login = ({ classes }) => {
  const dispatch = useDispatch();
  const { auth, authError } = useSelector(state => state);
  const { loading } = auth;
  const { error } = authError;

  const onSubmit = ({ email, password, rememberMe }) => {
    dispatch(Creators.getAuthRequest({ email, password, rememberMe }));
  };

  React.useEffect(() => {
    dispatch(Creators.getResetTokenRequest());
  }, []);

  return (
    <div
      className={classNames(
        classes.boxContainer,
        isMobile() ? classes.mobileContainer : {},
      )}
    >
      <div className={classes.boxWrapper}>
        <Paper className={classes.paper} elevation={3} square>
          <div className={classes.logoContainer}>
            <img
              style={{ maxWidth: '17%', height: 'auto' }}
              src={Logo}
              alt="Mini Mega Leitor"
            />
          </div>
          <LoginForm
            onFormSubmit={onSubmit}
            classes={classes}
            isLoading={loading}
            error={error}
            initialValues={{
              ...initialValues,
              ...auth.data,
            }}
          />
        </Paper>
      </div>
    </div>
  );
};

Login.propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withStyles(() => styles(), {
  withTheme: true,
})(Login);
